@if (inEdit) {
  <div class="grid-x">
    <div class="cell small-7"></div>
    <button class="button tiny cell small-2 pad-right" (click)="save()" [disabled]="form.invalid">SAVE</button>
    <button class="button tiny cell small-2" (click)="cancel()">CANCEL</button>
    <label class="cell small-12">
      Title
      <input type="text" [formControl]="form.controls.title" />
    </label>
    <label class="cell small-12">
      Identifier
      <input type="text" [formControl]="form.controls.identifier" />
    </label>
    <span class="checkbox">
      <input class="show-for-sr no-margin-bottom" type="checkbox" id="geodesic" [(ngModel)]="customSource" (ngModelChange)="toggleCustomSource($event)">
      <label for="geodesic" class="inline">
        <span class="checkbox-box" aria-hidden="true"><span class="checkbox-check" aria-hidden="true">&#x2714;</span></span>
        <span class="control-label-text">Use Custom Source</span>
      </label>
    </span>
    @if (!customSource) {
      <span class="cell small-12">
        <label>Server</label>
        <property-selector [properties]="services" (selectedProperty)="selectLayer($event)" (itemHoverChanged)="loadLayer($event)"></property-selector>
        <label>
          Selected Layer
          <p>{{form.controls.layerInformation.value?.name}}</p>
        </label>
      </span>
    }
    @if (customSource) {
      <label class="cell small-12">
        Custom Source URL
        <input type="text" [formControl]="form.controls.customSource" />
      </label>
    }
  </div>
} @else {
  <div class="grid-x">
    <h4 class="cell small-7">{{item?.title}}</h4>
    <button class="cell small-2 button tiny pad-right" (click)="inEdit = !inEdit">EDIT</button>
    <button class="cell small-2 button tiny" (click)="delete()">DELETE</button>
    <p class="cell small-4"></p>
  </div>
}


<ng-template #customSourceTemplate>
  <label class="cell small-12">
    Custom Source URL
    <input type="text" [formControl]="form.controls.customSource" />
  </label>
</ng-template>